'use strict';

module.exports = {
    /**
     * 扫描二维码并返回结果<br />
     * @method hysdk.scanQRCode
     * @category Fusion:Scan
     * @description
     * 与 Hy 环境用法、参数格式相同
     */
    scanQRCode: {
        service: 'Util',
        action: 'scanQRCode',
        tagname: 'scan_qrcode',
        resHandle: function resHandle(res) {
            return {
                resultStr: res.keyWords
            };
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ../plugins/ctrip/apis/scan.js
// module id = 46
// module chunks = 1 4